import { useMemo } from 'react';

import { TableColumn } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { renderCheckbox, renderIcon } from './renders';
import { NotificationSettingsTableItem } from './types';

export const getColumns = (): TableColumn<NotificationSettingsTableItem>[] => [
  {
    field: 'isBellEnabled' as 'name',
    title: '',
    width: 44,
    minWidth: 44,
    align: 'center',
    renderTitle: () => renderIcon(Icon.Bell),
    renderCell: () => renderCheckbox('onboardingStatus.isBellEnabled'),
  },
  {
    field: 'isEmailEnabled' as 'name',
    title: '',
    width: 44,
    minWidth: 44,
    renderTitle: () => renderIcon(Icon.Mail),
    renderCell: () => renderCheckbox('onboardingStatus.isEmailEnabled'),
  },
  {
    field: 'name',
    title: '',
    flex: 1,
  },
];

export const useColumns = () => useMemo(() => getColumns(), []);
